import axios from './../index'

class user {


    static userAdd(params) {
        return axios.post(`/app-admin/sys/user/insert`,params)
    }
    
    static userList(params) {
        return axios.get(`/app-admin/sys/user/list`,{params:params})
    }
    //编辑账号
    static userEdit(params) {
        return axios.post(`/app-admin/sys/user/update`,params)
    }

    //账号开关
    static switchState(adminId) {
        return axios.post(`/app-admin/sys/user/switchState/${adminId}`)
    }
    //账号是否存在
    static checkUserNameUnique(userName) {
        return axios.get(`/app-admin/sys/user/checkUserNameUnique/${userName}`)
    }

}

export default user;
